import { Zap, Clock } from 'lucide-react'

/**
 * Shown when a `.miniapp` has no `index.html` to serve. Triggers/schedulers can
 * run without a frontend, so we describe the background work — or, if there's
 * none, say the app isn't finished yet. Shared by the in-tab runner
 * (MiniAppRunView) and the standalone app window (AppWindow) so they never drift.
 */
export function MiniAppNoServeView({ triggered, scheduled }: { triggered: number; scheduled: number }) {
  if (triggered + scheduled === 0) {
    return (
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="text-center max-w-sm">
          <p className="text-lg themed-text mb-1">Nothing to run yet</p>
          <p className="text-sm themed-text-muted">This PDApp has no content to run — please wait for its author to complete the development.</p>
        </div>
      </div>
    )
  }
  return (
    <div className="flex-1 flex items-center justify-center p-8">
      <div className="text-center max-w-sm">
        <Zap size={30} className="mx-auto themed-icon mb-3" />
        <p className="text-lg themed-text mb-1">This PDApp runs in the background</p>
        <p className="text-sm themed-text-muted mb-4">It has no page to open — it works through:</p>
        <div className="flex items-center justify-center gap-2 flex-wrap">
          {triggered > 0 && (
            <span className="inline-flex items-center gap-1.5 text-sm px-3 py-1.5 rounded-full themed-bg-secondary themed-text">
              <Zap size={14} className="text-emerald-400" /> Triggered Tasks
            </span>
          )}
          {scheduled > 0 && (
            <span className="inline-flex items-center gap-1.5 text-sm px-3 py-1.5 rounded-full themed-bg-secondary themed-text">
              <Clock size={14} className="text-blue-400" /> Scheduled Tasks
            </span>
          )}
        </div>
        <p className="text-xs themed-text-muted mt-4">Review them in Settings.</p>
      </div>
    </div>
  )
}
